import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import styles from './order-payment-details.less';

const OrderPaymentDetails = ({ orderPaymentDetails }) => {
  if (_isEmpty(orderPaymentDetails)) {
    return <div />;
  }

  return (
    <div className={styles.orderPaymentDetails}>
      {orderPaymentDetails.map(
        ({ paymentMethodID, paymentMethodName, paymentMethodIcon }) => (
          <div key={paymentMethodID} className={styles.payment}>
            {paymentMethodIcon && (
              <img src={paymentMethodIcon} alt="" className={styles.icon} />
            )}
            {paymentMethodName && (
              <span className={styles.name}> {paymentMethodName} </span>
            )}
          </div>
        ),
      )}
    </div>
  );
};

OrderPaymentDetails.propTypes = {
  orderPaymentDetails: PropTypes.arrayOf(
    PropTypes.shape({
      paymentMethodID: PropTypes.string,
      amount: PropTypes.string,
      paymentMethodName: PropTypes.string,
      paymentMethodIcon: PropTypes.string,
    }),
  ),
};

OrderPaymentDetails.defaultProps = {
  orderPaymentDetails: undefined,
};

export default OrderPaymentDetails;
